// Homeowner earnings model. Lodging tax is paid by the guest on top of rent + cleaning, passes to the
// homeowner (who files and remits it) and is never part of any platform's commission.
// Competitor fees are typical published rates (Nov 2026) and vary by account; owners can adjust them.
export const FEE_DEFAULTS = {
  airbnbHostOnly: 15.5, // Airbnb single host-only fee (most hosts)
  airbnbSplitHost: 3, // Airbnb split fee: host part (legacy accounts)
  airbnbSplitGuest: 14.1, // Airbnb split fee: guest part, typically 14.1%+
  vrboHost: 12, // Vrbo all-in commission
  vrboGuest: 10, // Vrbo traveler service fee, varies by booking (~6-15%)
};

const r2 = (v) => Math.round(v * 100) / 100;

function scenario(key, name, subtotal, tax, hostPct, guestPct, note) {
  const guestFee = r2(subtotal * guestPct / 100);
  const hostFee = r2(subtotal * hostPct / 100);
  return {
    key, name, note, hostPct, guestPct, guestFee, hostFee, tax,
    guestTotal: r2(subtotal + guestFee + tax),
    platformFees: r2(guestFee + hostFee),
    hostReceives: r2(subtotal - hostFee + tax),
    hostEarnings: r2(subtotal - hostFee),
  };
}

export function earnings(subtotal, taxRate, fees = FEE_DEFAULTS) {
  const tax = r2(subtotal * taxRate / 100);
  return [
    scenario("fairstay", "FairStay", subtotal, tax, 10, 0, "Flat 10% from homeowners, no guest fee"),
    scenario("airbnb-host-only", "Airbnb (host-only fee)", subtotal, tax, fees.airbnbHostOnly, 0, `${fees.airbnbHostOnly}% host fee, no guest fee`),
    scenario("airbnb-split", "Airbnb (split fee)", subtotal, tax, fees.airbnbSplitHost, fees.airbnbSplitGuest, `${fees.airbnbSplitHost}% host + ${fees.airbnbSplitGuest}% guest`),
    scenario("vrbo", "Vrbo", subtotal, tax, fees.vrboHost, fees.vrboGuest, `${fees.vrboHost}% host + ~${fees.vrboGuest}% traveler fee`),
  ];
}
